import React, { useState, useEffect } from 'react';
import HomePage from './pages/Home';
import VideoPlayer from './pages/Player';

function App() {
  const [videoSrc, setVideoSrc] = useState(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const videoParam = urlParams.get("play");

    if (videoParam) {
      setVideoSrc(videoParam);
    }

    const hasPrompted = localStorage.getItem('telegramPrompted');
    if (!hasPrompted) {
      const joinChannel = window.confirm("Join Our Telegram Channel @star_ccricket");
      if (joinChannel) {
        window.open("https://telegram.me/star_ccricket", "_blank");
      }
      localStorage.setItem('telegramPrompted', 'true');
    }
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-black to-gray-900 flex justify-center items-center p-4">
      {!videoSrc ? <HomePage /> : <VideoPlayer videoSrc={videoSrc} />}
    </div>
  );
}

export default App;
